import React from "react";
import OrdersPage from "../../../features/admin/orders/orders-page";

export default function Orders() {
  return <OrdersPage />;
}
